<template>
  <CustomMask
    v-model="appStore.loginVisible"
    color="rgba(0, 0, 0, 0)"
    :closeOnClickOverlay="false"
  >
    <div class="login-container">
      <i-local-close-pop-up
        v-if="!isMobile"
        class="close-icon"
        @click="handleClose"
      />
      <i-local-chevron-left
        v-if="
          isMobile &&
          (currentStep === LOGIN_STEPS.METHODS ||
            (currentStep === LOGIN_STEPS.PHONE && isBindPhone))
        "
        class="chevron-left-icon"
        @click="handleClose"
      />

      <!-- <div class="logo-wrap">
        <img src="@/assets/images/logo/logo1.png" class="logo-img" />
      </div> -->
      <div class="logo-wrap">
        <img src="@/assets/images/logo/logo.png" class="logo-img" />
      </div>

      <div class="method-container">
        <transition name="fade-slide" mode="out-in">
          <component
            :is="stepComponents[currentStep]"
            :isMobile="isMobile"
            :methodsType="methodsType"
            @next="handleNext"
            @back="handleBack"
          />
        </transition>
      </div>
    </div>
  </CustomMask>
</template>

<script setup>
import { useDevice } from '@/utils/useDevice'

const router = useRouter()
const appStore = useAppStore()

const { isMobile } = useDevice()

const props = defineProps({
  isBindPhone: {
    type: Boolean,
    default: false
  }
})

const isBindPhone = computed(
  () => props.isBindPhone || appStore.isBindPhoneMode
)

const handleClose = () => {
  appStore.setLoginVisible(false)
}

// 登录步骤枚举
const LOGIN_STEPS = {
  METHODS: 'methods', // 选择方式
  STEP2: 'step2' // 选择方式
  // ACCOUNT: 'account', // 账号信息 (邮箱/密码/验证码)
  // PHONE: 'phone' // 手机绑定 (手机号/短信)
}

// 从 store 同步初始步骤，当 loginVisible 变化时也重置
const currentStep = ref(LOGIN_STEPS.METHODS)

// 监听 store 中的 loginStep 变化
watch(
  () => appStore.loginStep,
  (newStep) => {
    if (Object.values(LOGIN_STEPS).includes(newStep)) {
      currentStep.value = newStep
    }
  },
  { immediate: true }
)

// 监听登录弹窗关闭，重置本地状态
watch(
  () => appStore.loginVisible,
  (visible) => {
    if (!visible) {
      // 延迟重置，避免关闭动画过程中步骤变化
      setTimeout(() => {
        currentStep.value = LOGIN_STEPS.METHODS
      }, 300)
    }
  }
)

const methodsType = ref('')

const stepComponents = {
  [LOGIN_STEPS.METHODS]: defineAsyncComponent(
    () => import('./components/StepMethods.vue')
  ),
  [LOGIN_STEPS.STEP2]: defineAsyncComponent(
    () => import('./components/Step2.vue')
  )
  // [LOGIN_STEPS.ACCOUNT]: defineAsyncComponent(
  //   () => import('./components/StepAccount.vue')
  // ),
  // [LOGIN_STEPS.PHONE]: defineAsyncComponent(
  //   () => import('./components/StepPhone.vue')
  // )
}

const handleNext = (data) => {
  const transition = {
    [LOGIN_STEPS.METHODS]: () => {
      methodsType.value = data.methodsType
      // currentStep.value = LOGIN_STEPS.ACCOUNT
      currentStep.value = LOGIN_STEPS.STEP2
    },
    [LOGIN_STEPS.STEP2]: () => {
      handleClose()
    }

    // [LOGIN_STEPS.ACCOUNT]: () => {
    //   const shouldBindPhone =
    //     methodsType.value === 'register' || !data.hasBindPhone

    //   if (shouldBindPhone) {
    //     return (currentStep.value = LOGIN_STEPS.PHONE)
    //   }

    //   handleClose()
    // },

    // [LOGIN_STEPS.PHONE]: () => {
    //   handleClose()
    // }
  }

  transition[currentStep.value]?.()
}

const handleBack = () => {
  const actions = {
    [LOGIN_STEPS.STEP2]: () => {
      currentStep.value = LOGIN_STEPS.METHODS
    }
    // [LOGIN_STEPS.ACCOUNT]: () => {
    //   currentStep.value = LOGIN_STEPS.METHODS
    // },
    // [LOGIN_STEPS.PHONE]: () => {
    //   if (isBindPhone.value) return handleClose()

    //   currentStep.value = LOGIN_STEPS.ACCOUNT
    // }
  }

  actions[currentStep.value]?.()
}
</script>

<style lang="scss" scoped>
.login-container {
  @include flex-center(column);
  @include respond-up('md') {
    @include flex-center;
    overflow: hidden;
  }
  @include adapt($prop: width, $h5: 100vw, $pc: auto);
  @include adapt($prop: height, $h5: 100dvh, $pc: 596);
  @include adapt($prop: border-radius, $pc: 38);
  /* 
  @include adapt(
    $prop: background,
    $h5: url('@/assets/images/h5_bg.jpg') no-repeat center/cover,
    $pc: none
  ); */

  @include adapt($prop: background, $h5: #0b101d, $pc: none);

  .close-icon {
    position: absolute;
    @include adapt($prop: top, $pc: 11);
    @include adapt($prop: right, $pc: 18);
    @include adapt($prop: width, $pc: 30);
    @include adapt($prop: height, $pc: 30);
    cursor: pointer;
  }

  .chevron-left-icon {
    position: absolute;
    @include adapt($prop: top, $h5: 38);
    @include adapt($prop: left, $h5: 38);
    @include adapt($prop: width, $h5: 52);
    @include adapt($prop: height, $h5: 52);
    cursor: pointer;
  }

  .logo-wrap {
    @include flex-center;
    @include adapt($prop: width, $pc: 320);
    @include adapt($prop: height, $pc: 596);
    @include adapt($prop: padding-top, $h5: 114, $pc: 0);
    color: #fff;
    @include adapt(
      $prop: background,
      $h5: transparent,
      $pc: url('@/assets/images/login/pc_login_bg.png') no-repeat center/cover
    );

    &.display-none {
      display: none;
    }

    /* .logo-img1 {
      @include adapt($prop: width, $h5: 240, $pc: 184);
      @include adapt($prop: height, $h5: 304, $pc: 232);
    } */

    .logo-img {
      @include adapt($prop: width, $h5: 299, $pc: 184);
      @include adapt($prop: height, $h5: 299, $pc: 232);
    }
  }

  .method-container {
    @include adapt($prop: flex, $h5: 1);
    @include adapt($prop: width, $h5: 100%, $pc: 462);
    @include adapt($prop: height, $pc: 596);
    @include adapt(
      $prop: background,
      $h5: transparent,
      $pc: linear-gradient(346deg, #292530 0%, #000000 100%)
    );
  }
}
</style>
